// @TODO, create a mapping for API URLs based on partner and page
export { getCommonLandingPageDetails } from "./getCommonLandingPageDetails";
export { getCommonsHeaderData } from "./getCommonsHeaderData";
export { getLandingPageDetails } from "./getLandingPageDetails";
export { getMyPartnerMockListing } from "./getMyPartnerMockListing";
export { getNextPageRouteDetails } from "./getNextPageRouteDetails";
export { getOrderConfirmedDetails } from "./getOrderConfirmedDetails";
export { getOrderDetails } from "./getOrderDetails";
export { getOrderDetailsV2 } from "./getOrderDetailsV2";
export { getOrderListing } from "./getOrderListing";
export { getPassportDetails } from "./getPassportDetails";
export { getPolicyStatus } from "./getPolicyStatus";
export { getProductListing } from "./getProductListing";
export {
  getSeoLandingPageDetailsByCountry,
  getSeoLandingPageDetailsByCountryForPwa,
} from "./getSeoLandingPage";
export { getTravelAttributes } from "./getTravelAttributes";
